import i18n from '@/i18n';
import type { UserAccountType } from '@/features/profile/types';

const ACCOUNT_TYPE_KEYS: Record<UserAccountType, string> = {
  student: 'accountTypeStudent',
  instructor: 'accountTypeInstructor',
  management: 'accountTypeManagement',
  promoter: 'accountTypePromoter',
  parent: 'accountTypeParent',
  tutor: 'accountTypeTutor',
};

/** Display labels for profile account types (shown under @username). */
export function getAccountTypeLabel(accountType: UserAccountType): string {
  return i18n.t(ACCOUNT_TYPE_KEYS[accountType], { ns: 'profile' });
}
